// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1347":"668990cb","4547":"91043622"}[chunkId] + ".chunk.css";
};